(function($) {
    $(document).gp_ready(function(){

        $(document).on('gp_newsletter_subscribed', newsletter_response)
        function newsletter_response(e, data){
            const input = $("form.newsletter-form input[type=email]")
            const label = $("label.newsletter-label")
            const error_text = $("p.newsletter-error-text")
            const button = $("button.newsletter-button")

            if (data.success) {
                button.css("visibility", "hidden")
                label.hide()
                error_text.hide()

                input
                    .attr("disabled", "disabled")
                    .val(data.message)
                    .css("border", "none")
                    .css("background-color", "#71A798")
                    .css("color", "#0A3448")

                if (typeof data.email_hash !== "undefined" && data.email_hash) {
                    datalayer_push({
                        'event': 'ev.email_subscription',
                        'user': {
                            'email': data.email_hash
                        }
                    })
                }
            }
            else {
                input.css("border-color", "#D74429")
                label.css("color", "#D74429")
                error_text
                    .css("color", "#D74429")
                    .text(data.message)
                    .show()
            }
        }
    })

})(jQuery);